module.exports = __webpack_public_path__ + "static/social-3-887326f1d8075a0f34447fcd1534c0ba.png";